import LogoutIcon from '@/assets/icons/logout.svg?react';
import UserIcon from '@/assets/icons/user.svg?react';
import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover/popover.component';
import { AccountInfo } from '@azure/msal-browser';
import { useState } from 'react';
import { navbarTranslations } from '../navbar.messages';

interface UserInfoProps {
  account: AccountInfo | null;
  onLogout: () => void;
}

const getRole = (account: AccountInfo | null) => {
  if (!account) return '';

  const roles = account.idTokenClaims?.roles || [];
  let role = '';

  for (let i = 0; i < roles.length; i++) {
    const element = roles[i];
    if (element === 'core_team') {
      role = 'Core Team';
    } else {
      role = 'User';
    }
  }

  return role;
};

export const UserInfo = ({ account, onLogout }: UserInfoProps) => {
  const [openPopover, setOpenPopover] = useState(false);

  const handleLogout = () => {
    setOpenPopover(false);
    onLogout();
  };

  return (
    <Popover
      open={openPopover}
      onOpenChange={() => {
        setOpenPopover(!openPopover);
      }}
    >
      <PopoverTrigger asChild>
        <Button aria-label="user menu" data-testid="navbar-user-info" variant="icon" className="flex flex-row gap-x-6">
          <p>{account?.name}</p>
          <div className="bg-white w-9 h-9 rounded-full flex justify-center items-center">
            <UserIcon data-testid="navbar-user-icon" />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" side="bottom" sideOffset={24} className="p-0 min-w-[360px]">
        <div className="bg-light-gray px-4 py-3 border-b border-other-stroke">
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row gap-x-2 items-center">
              <div className="border border-other-stroke bg-white w-9 h-9 rounded-full flex justify-center items-center">
                <UserIcon role="img" aria-label="User icon" data-testid="navbar-user-info-icon" />
              </div>
              <div>
                <p data-testid="navbar-user-info-name" className="typo-primary-500">
                  {account?.name}
                </p>
                <p data-testid="navbar-user-info-email" className="typo-secondary text-secondary-text">
                  {account?.username}
                </p>
              </div>
            </div>
            <Button variant="ghost" aria-label="logout button" onClick={handleLogout}>
              <LogoutIcon data-testid="navbar-logout" className="text-system-error w-6 h-6 cursor-pointer" />
            </Button>
          </div>
        </div>
        <div className="p-4 flex flex-col gap-y-1">
          <div className="flex flex-col gap-y-1">
            <p data-testid="navbar-user-info-role-label" className="typo-label uppercase text-secondary-text">
              <T {...navbarTranslations.userInfoRole} />
            </p>
            <p data-testid="navbar-user-info-role-value" className="typo-primary-500">
              {getRole(account)}
            </p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
